import { Cell, RowData } from '@tanstack/table-core';
import { flexRender } from '@tanstack/react-table';
import React, { Fragment } from 'react';

import { TableRowProps } from '../types';

function TableRow<TData extends RowData>({ row, renderRowExpand }: TableRowProps<TData>) {
  const visibleCellLength = row.getVisibleCells().length;
  const isExpanded = row.getIsExpanded();

  const renderCell = (cell: Cell<TData, unknown>) => (
    <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
  );

  return (
    <Fragment key={row.id}>
      <tr>{row.getVisibleCells().map(renderCell)}</tr>
      {isExpanded && renderRowExpand && (
        <tr className="row__expand" style={{ padding: 0 }}>
          <td colSpan={visibleCellLength}>{renderRowExpand(row)}</td>
        </tr>
      )}
    </Fragment>
  );
}

export default TableRow;
